<template>
  <yxtf-dialog
    ref="dialog"
    :visible.sync="currVisible"
    :show-close="showClose"
    :modal="modal"
    :padding-size="paddingSize"
    fullscreen
    :before-close="handleBeforeClose"
    :append-to-body="appendToBody"
    :custom-class="`yxtbiz-o2o-zoom-dialog ${customClass} ${trident ? 'yxtbiz-o2o-zoom-dialog-max' : ''}`"
    :class="[className,outClass]"
    :destroy-on-close="destroyOnClose"
    @open="handleOpen"
    @closed="handleClosed"
    @opened="handleOpened"
    @close="handleClose"
  >
    <template  slot="title">
      <slot v-if="$slots.title" name="title"></slot>
      <div v-else-if="title" class="yxtbiz-o2o-zoom-dialog-title">
        <o2of-svg v-if="arrowLeft"
                  front
                  class="color-gray-8 hand"
                  width="24px"
                  height="24px"
                  name="left"
                  @click.native="() => closeDialog()"
        />
        <div class="yxtbiz-o2o-zoom-dialog-title-innier">{{ title }}</div>
      </div>
    </template>
    <template slot="default">
      <slot name="default"></slot>
    </template>
    <template slot="footer">
      <slot name="footer"></slot>
    </template>
  </yxtf-dialog>
</template>

<script>
const animationList = ['zoomIn', 'slideInRight'];
const trident = navigator.userAgent.toLowerCase().indexOf('trident') > -1; // IE内核
export default {
  data() {
    this.trident = trident;
    return {
      className: ''
    };
  },
  props: {
    beforeClose: Function,
    paddingSize: {
      type: String,
      default: 'empty'
    },
    modal: {
      type: Boolean,
      default: false
    },
    arrowLeft: Boolean, // 左关闭箭头
    customClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: false
    },
    destroyOnClose: Boolean,
    showClose: {
      type: Boolean,
      default: true
    },
    title: String,
    animationName: {
      type: String,
      default: 'zoomIn',
      validator: value => animationList.includes(value)
    },
    visible: Boolean,
    closeTip: {
      type: Boolean,
      default: true
    },
    outClass: String
  },
  methods: {
    hintBeforeHide(closeDialog) {
      this.$confirm(this.$t('pc_comp_drawer_confirmCancel' /* 当前操作尚未保存，是否确认取消？ */), this.$t('pc_comp_drawer_msgCancel' /* 确认取消？ */), {
        confirmButtonText: this.$t('pc_comp_drawer_confirm' /* 确定 */),
        cancelButtonText: this.$t('pc_comp_drawer_cancel' /* 取消 */),
        type: 'warning'
      }).then(() => {
        closeDialog();
      }).catch(()=> {});
    },
    handleBeforeClose(closeDialog) {
      if (!this.closeTip) return typeof this.beforeClose === 'function' ? this.beforeClose(closeDialog) : closeDialog();
      // 需要提示
      if (typeof this.beforeClose === 'function') {
        this.beforeClose(this.hide.bind(this, closeDialog));
      } else {
        this.hide(closeDialog, true);
      }
    },
    hide(closeDialog, cancel) {
      if (cancel) {
        this.hintBeforeHide(closeDialog);
      } else {
        closeDialog();
      }
    },
    handleOpen() {
      this.className = `animate__${this.animationName}`;
      this.$emit('open');
    },
    handleOpened() {
      this.className = 'animation-duration--0';
      this.$emit('handleOpened');
    },
    handleClosed() {
      this.$emit('closed');
    },
    handleClose() {
      this.$emit('close');
    },
    closeDialog() {
      this.$refs['dialog'].handleClose();
    }
  },
  computed: {
    currVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  }
};
</script>
<style lang="scss">
$component: ".yxtbiz-o2o-zoom-dialog";

#{$component} {
  max-width: unset;
  max-height: unset;

  &-max {
    max-width: 100% !important;
    max-height: 100% !important;
  }
  &-title {
    line-height: 28px;
    display: flex;
    align-items: center;
    &-innier{
       line-height: 28px;
       color: #262626;
       font-size: 20px;
    }
  }
  &.yxtf-dialog {
    border-radius: 0;
  }

  .yxt-scrollbar {
    height: 100%;
  }

  & > .yxtf-dialog__header {
    padding-top: 24px;
    padding-bottom: 24px;
  }

  .yxtf-dialog__headerbtn {
    top: 26px;
    right: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 14px;

    .yxtf-icon.yxtf-icon-close {
      color: #595959;
      font-weight: 600;
    }
  }

  .yxtf-dialog__body {
    flex: 1;
    // padding: 0;
  }

  .yxt-scrollbar__wrap {
    overflow-x: hidden;
  }

  .yxtf-dialog__footer {
    padding: 0;
  }
}

.animate__zoomIn {
  animation-name: zoomIn;
}

.animate__slideInRight {
  animation-name: slideInRight;
}

.animation-duration--0 {
  animation-duration: 0s;
}

@keyframes zoomIn {
  from {
    transform: scale(0.6, 0.6);
    opacity: 0;
  }

  100% {
    transform: scale(1, 1);
    opacity: 1;
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(60%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
